import type { GetProductSellingPlansQuery } from "@/types/storefront-api.gen";

type ProductVariantNode = Extract<
  GetProductSellingPlansQuery["nodes"][number],
  { __typename?: "ProductVariant" }
>;

export const createCareplanSellingPlansDataModel = (
  sellingPlansQuery?: GetProductSellingPlansQuery,
) => {
  if (!sellingPlansQuery) {
    return null;
  }

  const sellingPlans = sellingPlansQuery.nodes
    .filter((node): node is ProductVariantNode => {
      return node?.__typename === "ProductVariant";
    })
    .flatMap((node) => {
      return node.sellingPlanAllocations.edges.map(({ node: allocationNode }) => {
        const { priceAdjustments, sellingPlan } = allocationNode;

        return {
          ...sellingPlan,
          ...priceAdjustments?.[0],
        };
      });
    });

  const uniqueSellingPlans = sellingPlans.filter((plan, index, self) => {
    return (
      index ===
      self.findIndex((sellingPlan) => {
        return sellingPlan.id === plan.id;
      })
    );
  });

  return {
    all: uniqueSellingPlans,
    monthly: uniqueSellingPlans.find((plan) => {
      return plan.deliveryPolicy?.interval === "MONTH" && plan.deliveryPolicy?.intervalCount === 1;
    }),
  };
};
